import { Asset } from '@/api/generatedApi';
import { useRemoveAssetFromGroup } from '@/hooks/api/reports/useRemoveAssetFromGroup';
import { getAssetName } from '@/utils/assets';
import { DeleteModal } from './DeleteModal';
import { Alert } from '@mui/material';

export const RemoveAssetFromGroupModal = ({
  isOpen,
  onClose,
  onRemove,
  asset,
  reportId,
  groupId,
  assetCount,
}: {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  asset: Asset;
  reportId: string;
  groupId: string;
  assetCount: number;
}) => {
  const isLastAsset = assetCount === 1;

  return (
    asset?.id && (
      <DeleteModal
        title='Remove Asset from Group'
        isOpen={isOpen}
        onClose={onClose}
        useHook={useRemoveAssetFromGroup}
        hookParams={{ reportId, groupId }}
        mutateParams={{ assetId: asset.id }}
        item={asset}
        itemName={getAssetName(asset)}
        confirmButtonText='Remove'
        verb='remove'
        onConfirm={onRemove}
      >
        {isLastAsset && (
          <Alert severity='warning'>This is the last asset in the group. Removing it will delete the group.</Alert>
        )}
      </DeleteModal>
    )
  );
};
